import { motion } from "framer-motion";
import SectionHead from "../SectionHead";

const STEPS = [
    "Customer Drawing / Specification",
    "Technical Review",
    "Raw Material Selection",
    "Mould / Tool Preparation",
    "Material Cutting & Preparation",
    "Compression / Moulding Process",
    "Trimming & Finishing",
    "Drilling / Machining",
    "Dimensional Inspection",
    "Final Quality Inspection",
    "Packing & Dispatch",
];

export const Process = () => (
    <section id="process" className="py-24 md:py-32 scroll-mt-20">
        <div className="shell">
            <SectionHead
                num="03"
                overline="Manufacturing Process"
                title="From drawing to dispatch"
                desc="A controlled, inspection-driven flow — every stage is tracked, measured and documented."
            />

            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
                {STEPS.map((step, i) => (
                    <motion.div
                        key={step}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
                        data-testid={`process-step-${i + 1}`}
                        className="group relative bg-[#0e0e11] hover:bg-panel transition-colors duration-300 p-5 md:p-7 min-h-[150px] md:min-h-[170px] flex flex-col justify-between"
                    >
                        <div className="flex items-start justify-between">
                            <span className="font-display text-4xl md:text-5xl font-semibold text-zinc-800 group-hover:text-safety transition-colors duration-300">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            {i < STEPS.length - 1 && (
                                <span className="font-mono text-zinc-700 group-hover:text-safety transition-colors text-lg hidden md:block">
                                    →
                                </span>
                            )}
                        </div>
                        <div className="font-display uppercase font-medium tracking-wide text-sm md:text-base text-zinc-200 group-hover:text-zinc-50 leading-snug">
                            {step}
                        </div>
                        <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-safety group-hover:w-full transition-all duration-500" />
                    </motion.div>
                ))}

                <div className="relative bg-safety p-5 md:p-7 min-h-[150px] md:min-h-[170px] flex flex-col justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/70">
                        Outcome
                    </span>
                    <div className="font-display uppercase font-semibold tracking-wide text-base md:text-xl text-charcoal leading-snug">
                        Consistent, inspect-ready components — batch after batch
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Process;